import jsonShippings from '@/assets/shippings.json';
export const shopBase = {

    data(){
        return {
          shipping:jsonShippings,
          SHIP_INTERNATIONAL:5
        }
    },
    computed:{

    },
    methods: {
        isEmpty(row,attr){
          if(row && row[attr]){
            return (row[attr]==null || row[attr]=="")
          }
          return true;
        },
        getShopById(dataset,id){
            let res=null;
            if(dataset){
                res= this._.find(dataset,(shop)=>{
					return shop.id==id
				});
            }
            return res;
        },
        hasCategory(row){
          return (row && !this._.isEmpty(row.category))
        },
        hasContact(row){
          return (!this.isEmpty(row,'name') || !this.isEmpty(row,'nr') || !this.isEmpty(row,'tel') || !this.isEmpty(row,'email') )
        },
        
        hasShippingText(row){
          return !this.isEmpty(row,'shipText');
        },
        hasCoord(row){
          return this.getCoord(row).length>0;
        },

          getImageStyle(shop){
            return (shop)?{
              'background': 'url('+encodeURI(shop.img)+')'
            }:'';
          },
          getShippingAsString(shop){
            if(shop){
              let shippments=this._.includes(shop.ship, this.SHIP_INTERNATIONAL)?[this.SHIP_INTERNATIONAL]:shop.ship;
              return this.getArrayAsString(this.shipping,shippments);
            }
            return "";
          },
    }
}